// config.js
const API_BASE_URL = 'https://visioncareoptics.in/backend/api';

export default API_BASE_URL;